import { Routes, Route, Outlet } from "react-router-dom";
import Layout from "./components/Layout";
import Public from "./components/Public";
import Login from "./features/auth/Login";
import DashLayout from "./components/DashLayout";
import Welcome from "./features/auth/Welcome";
import UsersListFilter from "./features/users/UsersListFilter";
import EditUser from "./features/users/EditUser";
import NewUser from "./features/users/NewUser";
import Prefetch from "./features/auth/Prefetch";
import PersistLogin from "./features/auth/PersistLogin";
import RequireAuth from "./features/auth/RequireAuth";
import { ROLES } from "./config/roles";
import useTitle from "./hooks/useTitle";
import ActionsList from "./features/actions/ActionsList";
import EditAction from "./features/actions/EditAction";
import NewAction from "./features/actions/NewAction";
import ShowAction from "./features/actions/ShowAction";
// import ResponsesList from './features/responses/ResponsesList'
import EditResponse from "./features/responses/EditResponse";
import NewResponse from "./features/responses/NewResponse";
import TasksListFilter from "./features/tasks/TasksListFilter";
import ShowTask from "./features/tasks/ShowTask";
import NewTask from './features/tasks/NewTask'
import EditTask from "./features/tasks/EditTask";
import StudentGradeItem from "./features/grades/student/StudentGradeItem";
import StudentGradesListFilter from "./features/grades/student/StudentGradesListFilter";
import GradesListFilter from "./features/grades/GradesListFilter";
import GradeItem from "./features/grades/GradeItem";
import Profile from "./features/users/Profile";
import ReportsListFilter from "./features/reports/ReportsListFilter";
import EditMultiGrade from "./features/grades/EditMultiGrade";
import CompaniesList from "./features/companies/CompaniesList";
import EditCompany from "./features/companies/EditCompany";
import NewCompany from "./features/companies/NewCompany";
import GroupsList from "./features/groups/GroupsList";
import EditGroup from "./features/groups/EditGroup";
import NewGroup from "./features/groups/NewGroup";
import ChangeMultiGroup from "./features/users/ChangeMultiGroup";
import StudentReportsListFilter from "./features/reports/student/StudentReportsListFilter";
import 'react-quill/dist/quill.snow.css'; // import the styles
import LessonsListFilter from "./features/lesson/LessonsListFilter";
import EditLesson from "./features/lesson/EditLesson";
import NewLesson from "./features/lesson/NewLesson";
import ShowLesson from "./features/lesson/ShowLesson";
import PresencesListFilter from "./features/presence/PresenceListFilter";
import EditCourse from "./features/courses/EditCourse";
import CoursesList from "./features/courses/CoursesList";
import NewCourse from "./features/courses/NewCourse";
import QuestionSetsListFilter from "./features/questionSets/QuestionSetsListFilter";
import NewQuestionSet from "./features/questionSets/NewQuestionSet";
import EditQuestionSet from "./features/questionSets/EditQuestionSet";
import GenerateQuestionSetToUsers from "./features/questionSets/GenerateQuestionSetToUsers";
import UserQuestionListFilter from "./features/userQuestion/UserQuestionListFilter";
import Answer from "./features/userQuestion/Answer";
import GeneratedList from "./features/questionSets/GeneratedList";
import EditFinalQuestionSet from "./features/questionSets/EditFinalQuestionSet";
import UserQuestionListFilterAdmin from "./features/userQuestion/admin/UserQuestionListFilterAdmin";
import MessagesListFilter from "./features/messages/MessagesListFilter";
import NewMessage from "./features/messages/NewMessage";
import EditMessage from "./features/messages/EditMessage";
import FinalGradeBaseList from "./features/finalGrade/FinalGradeBaseList";
import FinalGradesListFilter from "./features/finalGrade/partial/FinalGradesListFilter";
import {createTheme} from "@mui/material/styles";
import {ThemeProvider} from "@mui/material/styles";
import CurrentResponse from "./features/grades/response/CurrentResponse";
import FriendResponse from "./features/grades/response/FriendResponse";
import SelectGroup from "./features/tasks/SelectGroup";
import DuplicateTasksGroup from "./features/groups/partial/DuplicateTasksGroup";
import TaskBasesListFilter from "./features/taskBases/TaskBasesListFilter";
import NewTaskBase from "./features/taskBases/NewTaskBase";
import EditTaskBase from "./features/taskBases/EditTaskBase";
import _NewAction from "./features/taskBases/actions/NewAction"
import _EditAction from "./features/taskBases/actions/EditAction"
import _ActionsList from "./features/taskBases/actions/ActionsListAddEdit"
import GroupToTaskBaseImporter from "./features/taskBases/GroupToTaskBaseImporter";
import TaskChartsFilter from "./features/grades-charts/TaskChartsFilter";
import StudentChartFilter from "./features/grades-charts/student/StudentChartFilter";
const theme = createTheme(
  {
      typography: {
          fontFamily: ['Noto Sans Hebrew', 'serif'].join(','),
          fontSize: 16,
          h2: {
              fontSize: "60px",
              fontWeight: "bold",
          }
      },
  }
)
function App() {
  useTitle("geshtop-Exercise");


  return (
    <ThemeProvider theme={theme}>
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* public routes */}
        <Route index element={<Public />} />
        <Route path="login" element={<Login />} />

        {/* Protected Routes */}
        <Route element={<PersistLogin />}>
          <Route
            element={<RequireAuth allowedRoles={[...Object.values(ROLES)]} />}
          >
            <Route element={<Prefetch />}>
              <Route path=":type" element={<DashLayout />}>
                <Route index element={<Welcome />} />
                <Route path=":groupId" element={<Outlet />}>
                  <Route index element={<Welcome />} />

                  <Route path="profile" element={<Profile />} />
                  <Route path="my-grades" element={<StudentGradesListFilter />} />
                  <Route path="final-grades" element={<FinalGradesListFilter />} />
                  <Route path="my-grades/:actionId" element={<StudentGradeItem />} />
                  <Route path="my-reports" element={<StudentReportsListFilter />} />
                  <Route path="my-presence" element={<PresencesListFilter />} />
                  <Route
                    element={
                      <RequireAuth allowedRoles={[ROLES.Teacher, ROLES.Admin]} />
                    }
                  >
                    <Route path="users">
                      <Route index element={<UsersListFilter />} />
                      <Route path=":userId" element={<EditUser />} />
                      <Route path="new" element={<NewUser />} />
                      <Route path="edit-groups" element={<ChangeMultiGroup />} />
                    </Route>
                    <Route path="grades" >
                      <Route index element={<GradesListFilter />} />
                      <Route path="task/:taskId" element={<GradesListFilter />}   /> 
                      <Route path="task/:taskId/search" element={<GradesListFilter />}   /> 
                      <Route path="task/:taskId/:responseId" element={<GradeItem />}   >
                        <Route index element={<CurrentResponse />} />
                        <Route path=":friendResponse" element={<FriendResponse />} />
                      </Route> 
                      <Route path="multi" element={<EditMultiGrade />}  />
                    </Route>
                    <Route path="reports" >
                      <Route index element={<ReportsListFilter />} />
                    </Route>
                    <Route path="lessons" >
                      <Route index element={<LessonsListFilter  />} />
                      <Route path=":lessonId" element={<EditLesson />} />
                      <Route path="new" element={<NewLesson />} />
                      <Route path="show/:lessonId" element={<ShowLesson />} />
                    </Route>

                  </Route>

          


                  <Route path="companies"
                    element={
                      <RequireAuth allowedRoles={[ROLES.Admin]} />
                    }
                  >
                   <Route index element={<CompaniesList />} />
                    <Route path=":id" element={<EditCompany />} />
                     <Route path="new" element={<NewCompany />} /> 
                  </Route>
                  <Route path="courses"
                    element={
                      <RequireAuth allowedRoles={[ROLES.Admin]} />
                    }
                  >
                   <Route index element={<CoursesList />} />
                    <Route path=":id" element={<EditCourse />} />
                     <Route path="new" element={<NewCourse />} /> 
                  </Route>


                  <Route path="groups"
                    element={
                      <RequireAuth allowedRoles={[ROLES.Teacher, ROLES.Admin]} />
                      
                    }
                  >
                   <Route index element={<GroupsList />} />
                    <Route path=":id" element={<EditGroup />}>
                      <Route path="final-grade" element={<FinalGradeBaseList />} /> 
                      <Route path="duplicate-all" element={<DuplicateTasksGroup />} /> 

                    </Route>
                     <Route path="new" element={<NewGroup />} /> 
                  </Route>

                  {/* <Route path="responses">
                    <Route index element={<ResponsesList />}  allowedRoles={[ROLES.Teacher, ROLES.Admin]}/>
                    <Route path=":id" element={<EditResponse />} />
                    <Route path="new" element={<NewResponse />} />
                  </Route> */}

                  <Route path="tasks">
                      <Route index element={<TasksListFilter />} />
                      <Route path=":taskId/actions" element={<ShowTask />}>
                        <Route index element={<ActionsList />} />
                        <Route path=":actionId/responses" element={<ShowAction />}>
                          <Route index element={<NewResponse />} />
                          <Route path="new" element={<NewResponse />} />
                          <Route path=":responseId" element={<EditResponse />} />
                        </Route>
                      
                      </Route>
                      <Route   element={  <RequireAuth allowedRoles={[ROLES.Teacher, ROLES.Admin]} />}>
                        <Route path="new" element={<NewTask />}   /> 
                        <Route path=":taskId" element={<EditTask />}   > 
                          <Route path="duplicate" element={<SelectGroup />}   /> 
                        </Route>
                        <Route path=":taskId/new" element={<NewTask />}   /> 
                        <Route path=":taskId/action/:actionId" element={<EditAction />}  />
                        <Route path=":taskId/action/new" element={<NewAction />}  />
                      </Route>
                  </Route>
                  <Route path="task-bases"  element={  <RequireAuth allowedRoles={[ ROLES.Admin]} />}>
                    <Route index  element={<TaskBasesListFilter />}  />
                    <Route path="list"  element={<TaskBasesListFilter />}  >
                      <Route path="import" element={<GroupToTaskBaseImporter />} />  
                    </Route>
                    <Route path=":taskBaseId" element={<EditTaskBase />} >
                      <Route index element={<_ActionsList />}   /> 
                      <Route path="actions/new" element={<_NewAction />}   /> 
                      <Route path="actions/:actionId" element={<_EditAction />}   /> 

                    </Route>
                    <Route path="new" element={<NewTaskBase />} />  


                  </Route>

                  <Route path="messages">                      
                      <Route   element={  <RequireAuth allowedRoles={[ROLES.Teacher, ROLES.Admin]} />}>
                        <Route index element={<MessagesListFilter />} />
                        <Route path="new" element={<NewMessage />}   /> 
                        <Route path=":messageId" element={<EditMessage />}   /> 
                        
                      </Route>
                  </Route>

                  <Route path="question-sets"
                    element={
                      <RequireAuth  allowedRoles={[ROLES.Teacher, ROLES.Admin]}/>
                    }
                  >
                   <Route index element={<QuestionSetsListFilter />} />
                   <Route path="new" element={<NewQuestionSet />}   /> 
                   <Route path="users-report" element={<UserQuestionListFilterAdmin />}   /> 
                   <Route path=":questionSetId" element={<EditQuestionSet />}   /> 
                   <Route path=":questionSetId/generate" element={<GenerateQuestionSetToUsers />}   /> 
                   <Route path=":questionSetId/final" element={<GeneratedList />}   /> 
                   <Route path="final/:finalQuestionSetId" element={<EditFinalQuestionSet />}   /> 

                  </Route>
                  <Route path="user-questions">
                    <Route index element={<UserQuestionListFilter />} />
                    <Route path=":userQuestionId" element={<Answer />}   /> 
                  </Route>
                  <Route path="charts" element={<Outlet />}>
                    <Route index element={<StudentChartFilter /> } />
                    <Route   element={  <RequireAuth allowedRoles={[ROLES.Teacher, ROLES.Admin]} />}>
                        <Route path="tasks" element={<TaskChartsFilter />} />
                    </Route>
                  </Route>

                  {/* <Route path="actions">
                    <Route index element={<ActionsList />} />
                    <Route path=":id" element={<EditAction />} />
                    <Route path="new" element={<NewAction />} />
                  </Route> */}
                </Route>
                {/* End Dash */}
              </Route>
            </Route>
          </Route>
        </Route>
        {/* End Protected Routes */}
      </Route>
    </Routes>
    </ThemeProvider>
  );
}

export default App;
